import { Button, message, Typography } from 'antd';
import React, { useEffect, useState } from 'react'
import LilyButton from '../../../../../components/button/lily-button';
import { useClaimContext } from '../../component/claim-context';
import FastLinkBank from '../../../../../containers/fast-link-bank/fast-link-bank';
import CardIcon from '../../../../../assets/card.svg';
import portalAPI from "../../../../../api/api";
import { UPDATE_SOAP_PROCESS_URL, YODLEE_GET_ACCOUNTS_DETAIL } from '../../../../../api/URLs';
import { useDispatch } from 'react-redux';
import { updateUser } from '../../../../../stores/authenticated-user.store';

const DirectDeposit = (props) => {
    const { setDisplayMethod } = props;
    const { Title, Text } = Typography;
    const [entityDirectDeposit, setEntityDirectDeposit] = useState(null);
    const [sites, setSites] = useState([]);
    const [accessToken, setAccessToken] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { claimForm, setClaimForm, setCurrent, linkedAccount, setLinkedAccount } = useClaimContext();
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            if (!entityDirectDeposit) {
                message.error('Please link your bank account before proceeding.');
                return;
            }

            let rsp = await portalAPI.put(UPDATE_SOAP_PROCESS_URL, { bankCard: entityDirectDeposit });
            if (rsp.status === 200) {
                //* Sync Redux store so reload preserves linked accounts
                if (rsp.data?.data?.reimbursementMethods) {
                    dispatch(updateUser({
                        key: 'reimbursementMethods',
                        value: rsp.data.data.reimbursementMethods,
                    }));
                }
                setClaimForm((prev) => ({
                    ...prev,
                    paymentInfo: {
                        ...prev.paymentInfo,
                        method: 'direct-deposit',
                        directDeposit: entityDirectDeposit,
                    },
                }));
                setCurrent(3);
            }
        } catch (error) {
            message.error(error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (claimForm.paymentInfo.directDeposit) {
            setEntityDirectDeposit(claimForm.paymentInfo.directDeposit);
        }
    }, [claimForm]);

    const getAccountsDetail = async (accountIds) => {
        try {
            const rsp = await portalAPI.post(YODLEE_GET_ACCOUNTS_DETAIL, {
                accountIds: accountIds,
                accessToken: accessToken,
            });
            if (rsp?.data?.data) {
                let data = rsp?.data?.data || [];
                // let reStructure = data.map((item) => ({
                //     container: item.CONTAINER,
                //     providerAccountId: `${item.providerAccountId}`,
                //     providerName: item.providerName,
                //     accountName: item.accountName,
                //     accountStatus: item.accountStatus,
                //     accountNumber: item.accountNumber,
                //     accountType: item.accountType,
                //     id: `${item.id || ''}`,
                //     balance: item.balance,
                //     bankTransferCode: item.bankTransferCode,
                // }));

                setLinkedAccount((prev) => {
                    const existingIds = new Set(prev.map((acc) => acc.id));
                    const newAccounts = data.filter(
                        (acc) => acc.id && !existingIds.has(acc.id)
                    );
                    return [...prev, ...newAccounts];
                });
            }
        } catch (err) {
            console.error("Error get accounts");
        }
    }

    useEffect(() => {
        if (sites.length > 0) {
            let accountIds = sites.map((item) => item.accountId);
            getAccountsDetail(accountIds);
        }
    }, [sites]);

    return (
        <div className='d-flex flex-column gap-4'>
            <div className='d-flex flex-column'>
                <Title className='mb-2 main-title' level={3}>
                    Direct Deposit Account
                </Title>
                <Text>
                    Save your bank details to get reimbursed faster. Securely receive payments straight to your bank account.
                </Text>
            </div>
            <div className='row g-3'>
                {
                    linkedAccount.length > 0 && linkedAccount.map((item) => {
                        let data = item;
                        let routingNumber = data?.bankTransferCode?.find((item) => item.type === 'ROUTING_NUMBER');
                        return (
                            <div className='col-md-6 col-12'>
                                <div className={`method-card is-option ${entityDirectDeposit && (entityDirectDeposit?.id === data.id) ? 'selected' : ''}`} onClick={() => setEntityDirectDeposit(item)}>
                                    <div className='d-flex flex-row align-items-start gap-3'>
                                        <img src={CardIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                                        <div className='d-flex flex-column'>
                                            <Title level={5} style={{ fontWeight: '500' }}>Direct Deposit (ACH)</Title>
                                            <Text strong>{data.providerName}</Text>
                                            <Text>Account Name: {data.accountName}</Text>
                                            <Text>Account Type: {data.accountType}</Text>
                                            <Text>Account Number: {data.accountNumber}</Text>
                                            <Text>Routing Number: {routingNumber?.id || 'N/A'}</Text>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <FastLinkBank setSites={setSites} setAccessToken={setAccessToken} />
            <div className='d-flex flex-row justify-content-end mt-5'>
                <Button
                    style={{ width: '200px' }}
                    color="default"
                    variant="link"
                    onClick={() => {
                        setDisplayMethod('');
                    }}
                >
                    Back
                </Button>
                <LilyButton style={{ width: '200px' }} loading={isLoading} onClick={handleSubmit} text="Next" />
            </div>
        </div>
    )
}

export default DirectDeposit;